module.exports = __webpack_public_path__ + "03_short_grey.acb7fef3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/03_short_grey.png
// module id = IKEh
// module chunks = 0